import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CertificadoDigitalComponent } from './certificado-digital.component';
import { FormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';

@NgModule({
  declarations: [CertificadoDigitalComponent],
  imports: [
    CommonModule,
    FormsModule,
    PoModule
  ],
  exports: [CertificadoDigitalComponent]
})
export class CertificadoDigitalModule { }

